<template>
  <section>
    <v-card>
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          The instructions is intended for the candidate (student).
<!--          This text will be used as a template for ind. marking-->
        </v-alert>
      </v-card-text>
      <v-card-text v-if="instruction">
        <vue-editor id="staff-scenario"
                    v-model="instruction.body"
                    :editor-toolbar="toolbar"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="success" @click="updateInstruction">Save</v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    instruction: null,
    api_errors: [],

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["image", "link", "formula"],
    ],
  }),
  created() {
    this.loadInstruction()
  },
  methods: {
    async loadInstruction() {
      this.instruction = await this.axios.get(`api/mocks/${this.$route.params.mock_id}/instruction`)
          .then(({data}) => data.data)
    },
    updateInstruction() {
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/instruction`, this.instruction)
          .then(({data}) => { this.instruction = data.data })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    }
  }
}
</script>